<script>
import VAutocompleteBigData from "@/components/VAutocomplete/VAutocompleteBigData.vue";
import _ from "lodash";
import roscongressUrl from "@/utils/roscongressUrl";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import Speaker from "@/components/commonComponents/Speaker.vue";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";

export default {
    name: "VAutocompleteSpeaker",
    components: {
        VIconTooltip,
        Speaker,
        AjaxLoad,
        VAutocompleteBigData,
    },
    inheritAttrs: false,
    props: {
        value: {},
        disabled: {
            type: Boolean,
        },
        idProject: {
            type: String,
        },
        idSessionBitrix: {
            type: Number,
        },
        language: {
            type: String,
        },
        idEventsBitrix: {
            type: Number,
        },
        idForumsBitrix: {
            type: Number,
        },
    },
    data() {
        return {
            filter: true,
            session: null,
            dictionaries: {
                speakers: [],
            },
        };
    },
    computed: {
        syncValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
        dictionariesSpeakersFiltered() {
            const speakersId = this.speakersId;
            return _.filter(this.dictionaries.speakers, v => speakersId.includes(v.id_speaker_bitrix) || v.id_speaker_eps === this.syncValue)
        },
        dictionariesSpeakersItems() {
            return this.filter ? this.dictionariesSpeakersFiltered : this.dictionaries.speakers;
        },
        selectedItem() {
            return _.find(this.dictionaries.speakers, {id_speaker_eps: this.syncValue});
        },
        speakerRoscongressUrl() {
            const selectedItem = this.selectedItem;
            return selectedItem && roscongressUrl.getSpeakerUrl(selectedItem);
        },
        speakerRoscongressBitrixUrl() {
            const selectedItem = this.selectedItem;
            return selectedItem && roscongressUrl.getSpeakerBitrixUrl(selectedItem);
        },
        speakersId() {
            return _([])
                .concat(_.map(this.session?.MODERATORS, 'VALUE'))
                .concat(_.map(this.session?.SPEAKERS, 'VALUE'))
                .concat(_.map(this.session?.PARTICIPANTS, 'VALUE'))
                .uniq()
                .value();
        },
        sessionUrl() {
            const options = Object.assign(
                {},
                this.$route.params,
                _.pickBy({
                    ID_FORUM: this.idForumsBitrix,
                    ID_EVENT: this.idEventsBitrix,
                }, _.isNumber),
                {ID_SESSION: this.idSessionBitrix}
            );
            return this.idSessionBitrix ? this.$apiUrl.getForumEventSessionUrl(options) : '';
        },
        languageWithDefault() {
            return this.language || 'ru';
        },
        itemTextField() {
            return 'name_' + this.languageWithDefault;
        },
    },
    watch: {
        language(v, o) {
            // Требуется обновить должность только при смене языка т.е. ru => en, en => ru
            // при первоначальной загрузке не обновляем, будет undefined => en
            if (o) {
                this.updateSpeakerPosition();
            }
        },
    },
    methods: {
        updateSpeakerPosition() {
            this.$nextTick(() => {
                if (this.selectedItem) {
                    this.$emit('update:speaker-position', this.selectedItem['position_' + this.languageWithDefault]);
                }
            });
        },
    },
}
</script>

<template>
    <ajax-load
        v-model="dictionaries.speakers"
        :active="!!idProject"
        :url="$apiUrl.getProjectDictionarySpeakersUrl({id_project: idProject})"
        :transform="response => response.data.data"
        v-slot="{active: activeSpeakers, resolved: resolvedSpeakers}"
    >
        <ajax-load
            v-model="session"
            :active="!!idSessionBitrix"
            :url="sessionUrl"
            :transform="response => response?.data?.data?.items[0]"
            v-slot="{active: activeSession, resolved: resolvedSession}"
        >
            <v-autocomplete-big-data
                ref="autocomplete"
                v-model="syncValue"
                v-bind="$attrs"
                v-on="$listeners"
                :items="dictionariesSpeakersItems"
                :disabled="disabled"
                :loading="(activeSession && !resolvedSession) || (activeSpeakers && !resolvedSpeakers)"
                :item-text="itemTextField"
                @input="updateSpeakerPosition"
                item-value="id_speaker_eps"
            >
                <template v-slot:append>
                    <v-icon-tooltip
                        v-if="!disabled"
                        :icon="filter ? 'mdi-filter-off' : 'mdi-filter'"
                        @click.stop="filter = !filter"
                    >
                        Фильтровать участников сессии
                    </v-icon-tooltip>

                    <v-icon-tooltip
                        v-if="speakerRoscongressUrl"
                        :href="speakerRoscongressUrl"
                        @click.stop
                        icon="mdi-web-check"
                        target="_blank"
                    >
                        Открыть спикера на Портале
                    </v-icon-tooltip>

                    <v-icon-tooltip
                        v-if="speakerRoscongressBitrixUrl"
                        :href="speakerRoscongressBitrixUrl"
                        @click.stop
                        icon="$ls-web-cog"
                        target="_blank"
                        class="ls-svg"
                    >
                        Открыть спикера в Битрикс
                    </v-icon-tooltip>

                    <div class="v-input__icon v-input__icon--append">
                        <v-icon :disabled="disabled">mdi-menu-down</v-icon>
                    </div>
                </template>
                <template v-slot:item="{item}">
                    <speaker :speaker="item" :language="languageWithDefault"></speaker>
                </template>
                <!--
                @TODO Стоило бы отображать это и в selection, но vuetify перестаёт выделять текст после открытия меню...
                    Возможно, поможет,
                    https://stackoverflow.com/questions/52820450/vuetify-autocomplete-item-slot-keep-the-highlighting-of-character
                    https://stackoverflow.com/questions/68918143/vuetify-v-autocomplete-doesnt-highlight-text-when-using-the-item-and-selection
                -->
            </v-autocomplete-big-data>
        </ajax-load>
    </ajax-load>
</template>

<style scoped lang="scss">
::v-deep {
    .v-btn {
        margin: -0px 0;
        height: 24px;
        width: 24px;

        &.v-btn--icon {
            .v-icon {
                &.mdi-web, &.mdi-web-check, &.mdi-filter, &.mdi-filter-off {
                    font-size: 22px;
                }
                &.ls-svg {
                    width: 22px;
                    height: 22px;
                }
            }
        }
    }
}
</style>
